const api = '/api/mlogin.php';
import axios from 'axios';
export const mLoginRepository =  {
    methods: {
        async Set(item){
            return  axios.post(api,item)
        }
    }
};

